import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector } from 'redux-form';
import { injectIntl } from 'react-intl';


import * as c from '../../../constants';

import { renderField, Validate } from '../../../../../common/form/FieldHelper';
import GroupTypeRadioField from '../fields/GroupTypeRadioField';
import GroupListDropdown from '../fields/GroupListDropdown';

import messages from '../../../translation_hotkey_template';


class AddGroupForm extends Component {
  constructor(props) {
    super(props);
    this.handleOnTypeChange = this.handleOnTypeChange.bind(this);
  }


  handleOnTypeChange() {
    const { change } = this.props;
    change("list", null);
  }


  render() {
    const { form, groupType, intl } = this.props;

    return (
      <div className="ui column grid ht-paddingless">
        <div className="row ht-small-padding">
          <div className="eight wide column">
            <Field
              type="text"
              name="name"
              label="Name"
              component={renderField}
              validate={[Validate.required]}
              translation={{label: { message: messages.label_name }}}
            />
          </div>
          <div className="eight wide column">
            <Field
              type="text"
              name="image_url"
              label="Image URL"
              placeholder="http://"
              component={renderField}
              validate={[Validate.url]}
              translation={{label: { message: messages.label_image_url }}}
            />
          </div>
        </div>
        <div className="one column row ht-small-padding">
          <div className="column">
            <GroupTypeRadioField 
              name="group_type"
              label="Type"
              onChange={this.handleOnTypeChange}
              translation={{label: { message: messages.label_type }}} 
            />
          </div>
        </div>
        <div className="row ht-small-padding">
          <div className="ten wide column">
            <GroupListDropdown 
              form={form} 
              name="list"
              label={groupType === c.FORM_GROUP_TYPE_CLASS ? intl.formatMessage( messages.label_classification ) : intl.formatMessage( messages.label_items ) }
            />
          </div>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state, { form }) {
  const getField = formValueSelector(form);
  
  return {
    groupType: getField(state, 'group_type')
  };
}


export default injectIntl(connect(mapStateToProps)(AddGroupForm));
